import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { FoundationNotFoundComponent } from './not-found.component';

@NgModule({
    declarations: [ FoundationNotFoundComponent ],
    imports: [ MatCardModule ],
    exports: [ FoundationNotFoundComponent ]
})
export class FoundationNotFoundModule {}
